(function () {
    'use strict';
    angular.module('SMART2').service('httpService', ['$http', '$q', 'APPCONSTANTS', function ($http, $q, APPCONSTANTS) {
        delete $http.defaults.headers.common['X-Requested-With'];

        var httpService = this;
        var pendingRequests = [];
        httpService.isNetworkOnline = true;

        /*
         * Lister network change
         */
        // window.on('networkChange', function(e) {
        // httpService.isNetworkOnline = e.online;
        // if(!e.online) {
        // httpService.abortAll(true);
        // }
        // });

        /*
         * Massage result data
         * This is required because sometimes if a service fails, the same is notified in success callback
         */
        httpService.massageResultData = function (data) {
            data.success = true;
            if (data.config.timeout && angular.isDefined(data.config.timeout.status)) {
                data.status = data.config.timeout.status;     //  timeout can be either actual service timeout or request abort
                data.statusText = data.config.timeout.statusText;
                data.success = false;
            }
            else if ([200, 201, 202, 203].indexOf(data.status) == -1) {
                data.statusText = 'An error occured while fetching data.';
                data.success = false;
            }
            return data;
        };


        /*
         *  Abort all pending requests
         *  Services added to 'excludeServices' array will be skipped (will not be aborted)
         */
        httpService.abortAll = function (isNetworkLost) {
            angular.forEach(pendingRequests, function (pendingRequest) {
                pendingRequest.canceller.promise.status = isNetworkLost ? 0 : 499;
                pendingRequest.canceller.promise.statusText = isNetworkLost ? 'The Internet connection appears to be offline.' : 'Request cancelled.';
                pendingRequest.canceller.resolve();
            });
            pendingRequests = [];
        };


        /*
         *  Abort request
         */
        httpService.abort = function (urlfordata) {
            if (!urlfordata) {
                return;
            }
            var requestToAbort = undefined;
            requestToAbort = _.find(pendingRequests, function (pendingRequest) {
                return pendingRequest.url == urlfordata.url && angular.equals(pendingRequest.requestArgs, (urlfordata.params ? urlfordata.params : (urlfordata.data ? urlfordata.data : {})));
            });
            
            if(requestToAbort && requestToAbort.canceller && requestToAbort.canceller.promise){
                requestToAbort.canceller.promise.status = 499;
                requestToAbort.canceller.promise.statusText = 'Request cancelled.';
                requestToAbort.canceller.resolve();
            }
            pendingRequests = _.filter(pendingRequests, function (pendingRequest) {
                return pendingRequest.url != urlfordata.url && !angular.equals(pendingRequest.requestArgs, (urlfordata.params ? urlfordata.params : (urlfordata.data ? urlfordata.data : {})));
            });
        };


        /*
         * Get data from service
         */
        httpService.directhttp = function (urlfordata) {
            var returnpromise = $q.defer();

            var responseURL = 'Result';
            var requestPromise, canceller = $q.defer();

            /*
             *  If you don't want a service to be aborted on abortAll(), 
             *  pass a parameter named 'abortable' and set the value to false.
             *  abort() can still be used to abort the same service.
             */
            var abortable = angular.isDefined(urlfordata.abortable) && urlfordata.abortable == false ? false : true;
            /*
             * Service timeout
             */
            var requestTimeout = setTimeout(function () {
                canceller.promise.status = 408;
                canceller.promise.statusText = 'Request timed out.';
                canceller.resolve();
            }, angular.isDefined(urlfordata.timeout) ? urlfordata.timeout : 120000);

            if (abortable) {
                pendingRequests.push({
                    url: urlfordata.url,
                    requestArgs: urlfordata.params || urlfordata.data,
                    canceller: canceller
                });
            }

            var reqParams = {
                url: urlfordata.url,
                method: urlfordata.method ? urlfordata.method.toUpperCase() : "POST",
                cache: false,
                timeout: canceller.promise,
                headers: {
                    "Content-Type": "application/json",
                    "UserExecutionContext": JSON.stringify(APPCONSTANTS.userPreferences.UserBasicDetails)
                }
            };

            if (!reqParams.headers.RequestVerificationToken && $('#hdnToken').val()) {
                reqParams.headers.RequestVerificationToken = $('#hdnToken').val();
            }

            var IsNewJWTTokenEnabled = false;
			if(APPCONSTANTS.userPreferences.DocumentTypeId == 8 && APPCONSTANTS.userPreferences.DocumentSettings && APPCONSTANTS.userPreferences.DocumentSettings.lstSettings)
			{
				var IsNewJWTTokenEnabledforOrder = _.filter(APPCONSTANTS.userPreferences.DocumentSettings.lstSettings, { FieldName: "IsNewJWTTokenEnabled" });
				IsNewJWTTokenEnabled = IsNewJWTTokenEnabledforOrder && IsNewJWTTokenEnabledforOrder.length > 0 ? IsNewJWTTokenEnabledforOrder[0].FieldValue.toLowerCase() == "true" : false;
			}

            if(urlfordata.enableToken || IsNewJWTTokenEnabled){
                if (APPCONSTANTS.userPreferences.jwtToken && APPCONSTANTS.userPreferences.APIMSubscriptionKey) {
                    reqParams.headers["Authorization"] = (APPCONSTANTS.userPreferences.jwtToken.indexOf("Bearer ")>-1)
                                                            ? APPCONSTANTS.userPreferences.jwtToken
                                                            : "Bearer " + APPCONSTANTS.userPreferences.jwtToken;
                    reqParams.headers["Ocp-Apim-Subscription-Key"] = APPCONSTANTS.userPreferences.APIMSubscriptionKey;
                    reqParams.headers["BPC"] = APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode;
                    reqParams.headers["RegionID"] = APPCONSTANTS.userPreferences.RegionID;
                }
            }

            if (urlfordata.ReturnTrace) {
                reqParams.headers["ReturnTrace"] = urlfordata.GEPSmartTransactionId;
            }

            if (urlfordata.GEPSmartTransactionId) {
                reqParams.headers["GEPSmartTransactionId"] = urlfordata.GEPSmartTransactionId;
            }

            angular.merge(reqParams, urlfordata);

            requestPromise = $http(reqParams).then(function (result) {
                result = httpService.massageResultData(result);
                if (result.success) {
                    returnpromise.resolve(result.data);
                }
                else {
                    returnpromise.reject(result);
                }
            }, function (errorData) {
                errorData = httpService.massageResultData(errorData);
                returnpromise.reject(errorData);
            });


            /*
             *  Once a request has failed or succeeded, remove it from the pending list
             */
            requestPromise.finally(function () {
                clearTimeout(requestTimeout);
                if (abortable) {
                    pendingRequests = _.filter(pendingRequests, function (pendingRequest) {
                        return pendingRequest.url != urlfordata.url && !angular.equals(pendingRequest.requestArgs, ((urlfordata.params ? urlfordata.params : (urlfordata.data ? urlfordata.data : {}))));
                    });
                }
            });

            return returnpromise.promise;
        };

        httpService.directhttpFileDownloadURL = function(request, overloadFileName) {
            return $http(request).then(function(response){
                var contentDisposition = response.headers("content-disposition");
                var index = contentDisposition.indexOf("filename=") + 9;
                var fileName = overloadFileName == '' ? contentDisposition.substring(index) : overloadFileName;
                fileName = fileName.replace(/\"/g, "");
                var contentType = response.headers("content-type");
                var blob = new Blob([response.data], { type: contentType });
                var downloadURL = URL.createObjectURL(blob);
                return {
                    url: downloadURL,
                    fileName: fileName
                };
            }, function(error) {
                return {
                    url: '',
                    fileName: ''
                };
            })
        };
    }]);
})();
